import { render, staticRenderFns } from "./CustomizePage.vue?vue&type=template&id=a996771c"
import script from "./CustomizePage.vue?vue&type=script&lang=js"
export * from "./CustomizePage.vue?vue&type=script&lang=js"
import style0 from "./CustomizePage.vue?vue&type=style&index=0&id=a996771c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports